import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;
@Component({
  selector: 'app-add-update-location',
  templateUrl: './add-update-location.component.html',
  styleUrls: ['./add-update-location.component.css']
})
export class AddUpdateLocationComponent implements OnInit {

  locationForm: FormGroup;submitted = false;loading:boolean=false;circles=[];passwordhide:boolean = true;LocationId: any = '';circles_copy=[];cityList=[];cityList_copy=[];

  constructor(private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,private activatedRoute: ActivatedRoute,public miscapi:MiscService, private leadapi:LeadsService)
  {

      this.locationForm = this.formBuilder.group({
          'city_id' : [null, Validators.required],
          'name' : [null, Validators.required],
          'status' : [null, Validators.required]
      });

      this.activatedRoute.params.subscribe(params => {
          if (params['location_id']) {
              this.LocationId = params['location_id'];
              this.patchLocationData();
          }

      });

  }
  async getCityList()
  {  
      await this.leadapi.getcities().subscribe((data:any) => {
          if(data.status)
          {
            this.cityList = data.data;
            this.cityList_copy = this.cityList;

          }else{
              this.cityList = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  get f() { return this.locationForm.controls; }

  async patchLocationData()
  {
      this.miscapi.getLocationData(this.LocationId).subscribe((response:any) => {
         console.log(response);
         if(response.status){
             this.locationForm.patchValue({
               'city_id':response.data.city_id,
               'name':response.data.name,
               'status':response.data.status
              })
         }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  ngOnInit(): void
  {
     this.getCityList();
  }

  async createLocation(){
      this.submitted = true;
      this.loading = true;
      // stop here if form is invalid
      if (this.locationForm.invalid) {
          this.loading = false;
          return;
      }
      //For Update Treatment//
      if(this.LocationId){
        this.locationForm.value.id= parseInt(this.LocationId);

      await this.miscapi.updateLocation(this.locationForm.value)
      .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast('Location Update Successfully');
              this.router.navigateByUrl('/locations');
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
      }else{
          //For Add Treatment//
          console.log(this.locationForm.value);
        await this.miscapi.addLocation(this.locationForm.value)
       .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast('Location Added Successfully');
              this.router.navigateByUrl('/locations');
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
      }
}

setSearchValue(type){
    if(type=='city'){
        $("#citySearch").val('');
        $("#citySearch").focus();
        this.cityList= this.cityList_copy;
    }
}

searchOnSelect(searchtText: string, type){
    if (type == 'city') {
        this.cityList = this.sharedapi.searchData(searchtText, this.cityList_copy, "name");
    }
}



}
